/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import CSSModules from 'react-css-modules';
import isEqual from 'lodash/isEqual';
import isNil from 'lodash/isNil';
import React from 'react';
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import {
  Nav,
  Navbar,
  NavItem,
} from 'react-bootstrap';
import HideIf from 'loracoms/HideIf';
import config from 'loracfg';
import LangSwitcher from '../LangSwitcher';
import UserDropdown from '../UserDropdown';
import styles from './styles.scss';
import imgLogo from './images/logo-inverse.svg';


const kHideMenuPaths = [
  '/login',
  '/register',
  '/lostpassword',
  '/password_reset',
  '/register_success',
];

const propTypes = {
  push: React.PropTypes.func.isRequired,
  menus: React.PropTypes.array.isRequired,
  pathname: React.PropTypes.string.isRequired,
  intl: React.PropTypes.any.isRequired,
  basic: React.PropTypes.object.isRequired,
  authed: React.PropTypes.bool.isRequired,
};

class ConsoleNavbar extends React.Component {

  static shouldHideMenus(pathname) {
    const pn = `/${pathname.split('/')[1]}`;
    return kHideMenuPaths.includes(pn);
  }

  constructor(props) {
    super(props);
    this.state = {
      menus: props.menus,
      activeMenu: this.activeMenu(),
      expanded: false,
      basic: props.basic,
      transparent: false,
      pathname: props.pathname,
    };
    this.handleGotoHome = this.handleGotoHome.bind(this);
  }

  componentWillMount() {
    this.setState({
      activeMenu: this.activeMenu(),
      transparent: this.transparent(),
    });
  }

  componentWillReceiveProps(nextProps) {
    const { menus, pathname, basic, authed } = nextProps;
    if (!isEqual(menus, this.props.menus)) {
      this.setState({ menus });
    }
    if (!isEqual(pathname, this.props.pathname)) {
      this.setState({ pathname });
    }
    if (!isEqual(basic, this.props.basic)) {
      this.setState({ basic });
    }
    if (!isEqual(authed, this.props.authed)) {
      this.setState({ authed });
    }

    this.setState({
      activeMenu: this.activeMenu(nextProps),
      transparent: this.transparent(nextProps),
    });
  }

  activeMenu(props) {
    let { pathname, menus } = props || this.props;
    pathname = `/${pathname.split('/')[1]}`;
    menus = _.filter(menus, m => (!m.static));
    const idx = _.findIndex(menus, { link: pathname });
    return idx;
  }

  transparent(props) {
    const { pathname } = props || this.props;
    return ConsoleNavbar.shouldHideMenus(pathname);
  }

  handleGotoHome() {
    const { locale } = this.props.intl;
    window.location = `/?locale=${locale}`;
  }

  renderSignup() {
    return [(
      <NavItem
        key={1}
        onSelect={() => {
          this.props.push('/login');
          this.setState({ expanded: false });
        }}
      >
        <FormattedMessage id="common.login" />
        {' '}
        <i className="fa fa-fw fa-sign-in" aria-hidden="true" />
      </NavItem>
    ), (
      <HideIf if="profile:cube" key={2}>
        <NavItem
          onSelect={() => {
            this.props.push('/register');
            this.setState({ expanded: false });
          }}
        >
          <FormattedMessage id="common.register" />
          {' '}
          <i className="fa fa-fw fa-user-plus" aria-hidden="true" />
        </NavItem>
      </HideIf>
    )];
  }

  renderRightMenu() {
    const { basic } = this.state;
    const { pathname } = this.state;

    let showUser = true;
    if (isNil(basic.data) ||
      pathname === '/login' ||
      pathname === '/register' ||
      pathname === '/lostpassword') {
      showUser = false;
    }

    if (showUser) {
      return <UserDropdown onSelect={() => this.setState({ expanded: false })} />;
    }
    return this.renderSignup();
  }

  render() {
    const { menus, pathname, transparent } = this.state;
    const navItems = menus.map((m, idx) => {
      let onSelAction;
      if (m.static) {
        onSelAction = () => window.open(m.link);
      } else {
        onSelAction = () => this.props.push(m.link);
      }
      return (
        <NavItem
          key={idx}
          eventKey={idx}
          onSelect={(ek) => {
            if (m.static) {
              this.setState({
                expanded: false,
              });
            } else {
              this.setState({
                activeMenu: ek,
                expanded: false,
              });
            }
            onSelAction();
          }}
        >
          <span styleName={`menu-item ${m.beta ? 'beta' : ''}`}>{m.name}</span>
        </NavItem>
      );
    });

    const hideMenus = ConsoleNavbar.shouldHideMenus(pathname);

    return (
      <div styleName={`navbar-wrapper ${transparent ? 'navbar-transparent' : ''}`}>
        <Navbar
          bsStyle="aisz-transparent"
          expanded={this.state.expanded}
          onToggle={() => this.setState({
            expanded: !this.state.expanded,
          })}
          fixedTop
        >
          <Navbar.Header>
            <Navbar.Brand>
              <div styleName="navbar-logo">
                <Link onClick={this.handleGotoHome}>
                  <img alt="" src={imgLogo} className="img-responsive" />
                </Link>
              </div>
              <div styleName="navbar-brand-text">loraFlow</div>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <HideIf if={hideMenus}>
              <Nav activeKey={this.state.activeMenu}>
                { navItems }
              </Nav>
            </HideIf>
            <HideIf if={config.profile === 'cube' || !_.isNil(config.language)}>
              <Nav pullRight>
                <LangSwitcher />
              </Nav>
            </HideIf>
            <Nav pullRight>
              {this.renderRightMenu()}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }
}

ConsoleNavbar.propTypes = propTypes;

const mapStateToProps = state => ({
  authed: state.auth.authed,
  basic: state.account.basic,
});

const mapDispatchToProps = dispatch => ({
  push: (...args) => dispatch(push(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(CSSModules(ConsoleNavbar, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/App/coms/ConsoleNavbar/index.jsx